import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import useNewBuildCheck from "./useNewBuildCheck";
import { UPDATE_NOTICE_TEXT_KEY } from "./newBuild";
import { NoticeBox, NoticeText, ReloadButton, reload } from "./styles";

export { default as UpdateNoticeBoundary } from "./UpdateNoticeBoundary";

/**
 * Shown when the server already serves a newer build than this tab runs.
 * The page never reloads by itself: a new order may be open unsaved.
 */
const UpdateNotice = memo(() => {
	const { t } = useTranslation();
	const found = useNewBuildCheck();

	if (!found) return null;

	const text = t(`${UPDATE_NOTICE_TEXT_KEY}.text`);
	return (
		<NoticeBox role="status">
			<NoticeText title={text}>{text}</NoticeText>
			<ReloadButton type="button" onClick={reload}>
				{t(`${UPDATE_NOTICE_TEXT_KEY}.reload`)}
			</ReloadButton>
		</NoticeBox>
	);
});

export default UpdateNotice;
